import { render, staticRenderFns } from "./SortHeader.vue?vue&type=template&id=0539f7f8&scoped=true&"
import script from "./SortHeader.vue?vue&type=script&lang=js&"
export * from "./SortHeader.vue?vue&type=script&lang=js&"
import style0 from "./SortHeader.vue?vue&type=style&index=0&id=0539f7f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0539f7f8",
  null
  
)

export default component.exports